import { Controller } from "@hotwired/stimulus"
import {Turbo} from "@hotwired/turbo-rails";
import { notifyParentOfWordModalOpen, notifyParentOfWordModalClose } from "../utils/iframe_messaging";

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", (event) => {
      event.preventDefault()
      this.open(event)
    })
  }

  open(event) {
    const {word, char, location} = this.element.dataset;
    if(char != 'word')
      return
      
    // Notify parent of modal open
    const modalData = {
      word: word,
      location: location,
      char: char,
      timestamp: Date.now()
    };
    notifyParentOfWordModalOpen(modalData);
    
    const modal = document.getElementById("word-modal")
    const modalContent = document.getElementById("word-modal-content")
    const backdrop = document.getElementById("word-modal-backdrop")
    const loading = modal.querySelector("#loading")
    const closeBtn = $(modal).find(".close-modal")
    closeBtn.on("click", () => this.close())

    modal.classList.remove("hidden")
    backdrop.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")

    void modal.offsetWidth

    modal.classList.add("flex")
    backdrop.classList.replace("opacity-0", "opacity-100")
    modalContent.classList.replace("scale-95", "scale-100")
    modalContent.classList.replace("opacity-0", "opacity-100")

    const fetchOptions = {
      method: 'GET',
      headers: {
        Accept: 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml'
      }
    };

    fetch(`/words/${word}`, fetchOptions)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then(html => {
        Turbo.renderStreamMessage(html);
        loading.classList.add("hidden")
      })
      .catch(error => console.error('Turbo stream fetch error:', error));
  }

  close() {
    // Notify parent of modal close
    notifyParentOfWordModalClose();
    
    const modal = document.getElementById("word-modal")
    const modalContent = document.getElementById("word-modal-content")
    const backdrop = document.getElementById("word-modal-backdrop")
    backdrop.classList.replace("opacity-100", "opacity-0")
    modalContent.classList.replace("scale-100", "scale-95")
    modalContent.classList.replace("opacity-100", "opacity-0")
    document.body.classList.remove("overflow-hidden")
    document.getElementById('word_content').innerText = ''
    const loading = modal.querySelector("#loading")

    loading.classList.remove("hidden")

    setTimeout(() => {
      modal.classList.add("hidden")
      backdrop.classList.add("hidden")
      modal.classList.remove("flex")
    }, 300)
  }
}
